// src/components/SignUp.js
import React from "react";
import { Box, TextField, Button, Typography } from "@mui/material";
import { MainContext } from "../../App";
import { useAuthStore } from "../../@shared/store/useAuthStore";
import NeoButton from "../NeoButton";
import { db } from "../../@shared/firebase/config";
import Toast from "../Toast";
import { validateAuthInputs } from "../../@shared/utils/Utils";

const SignUp = () => {
  const { signUp } = useAuthStore();
  const {
    setSuccess,
    setError,
    setMessage,
    Theme,
    gameScreenLoading,
    setGameScreenLoading,
  } = React.useContext(MainContext);
  const [username, setUsername] = React.useState("");
  const [email, setEmail] = React.useState("");
  const [password, setPassword] = React.useState("");
  const [loading, setLoading] = React.useState(false);

  const handleSignUp = async () => {
    if (!username || !email || !password) {
      setMessage("Please fill out all fields.");
      setError(true);
      return;
    }

    setLoading(true);

    const validFields = validateAuthInputs({
      username,
      email,
      password,
    });
    const { status, message } = validFields;
    if (!status) {
      setMessage(message);
      setError(true);
      setLoading(false);
      return;
    }

    try {
      await signUp(
        username.toLowerCase().trim(),
        email.toLowerCase().trim(),
        password.trim(),
        null,
        setGameScreenLoading
      );
      setSuccess(true);
      setMessage("You have been logged in!");
    } catch (error) {
      setGameScreenLoading(false);
      setError(true);
      setMessage(`Oops, there was an error. ${error}. Please Try again!`);
      setLoading(false);
    }
  };

  return (
    <Box sx={{ width: "300px", textAlign: "center" }}>
      <Toast onFinish={() => {}} timeTilClose={4000} />
      <Typography
        variant="h5"
        sx={{ marginBottom: "1rem", fontWeight: "bold" }}
      >
        Sign Up
      </Typography>
      <TextField
        fullWidth
        label="User Name"
        variant="outlined"
        value={username}
        onChange={(e) => setUsername(e.target.value)}
        sx={{ marginBottom: "1rem" }}
      />
      <TextField
        fullWidth
        label="Email"
        variant="outlined"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        sx={{ marginBottom: "1rem" }}
      />
      <TextField
        fullWidth
        label="Password"
        variant="outlined"
        type="password"
        value={password}
        onChange={(e) => setPassword(e.target.value)}
        sx={{ marginBottom: "1rem" }}
      />
      {/* <Button
        variant="contained"
        fullWidth
        onClick={() => signUp(username, email, password)}
      >
        Sign Up
      </Button> */}
      <NeoButton
        disabled={!!loading || !username || !email || !password}
        onClick={handleSignUp}
        width={100}
        text="Sign Up"
        color={Theme.palette.primary.main}
      />
    </Box>
  );
};

export default SignUp;
